import React from 'react';
import { useTranslation } from 'react-i18next';
import { List, Image } from '@chakra-ui/react';

type Props = {};

export const Chrome = (props: Props) => {
    const { t } = useTranslation();
    return (
        <List.Root as="ol" listStyle="decimal" marginLeft={4}>
            <List.Item _marker={{ color: 'inherit' }}>{t('operatingInstructionsScreen.chrome.one')}</List.Item>
            <List.Item _marker={{ color: 'inherit' }}>{t('operatingInstructionsScreen.chrome.two')}</List.Item>
            <List.Item _marker={{ color: 'inherit' }}>{t('operatingInstructionsScreen.chrome.three')}</List.Item>
            <Image src="/img/chrome/screen.png" marginTop={4} marginBottom={4} alt="image" />
            <List.Item _marker={{ color: 'red' }} color="red">
                {t('operatingInstructionsScreen.chrome.four')}
            </List.Item>
            <List.Item _marker={{ color: 'red' }} color="red">
                {t('operatingInstructionsScreen.chrome.five')}
            </List.Item>
            <List.Item _marker={{ color: 'red' }} color="red">
                {t('operatingInstructionsScreen.chrome.six')}
            </List.Item>
        </List.Root>
    );
};
